import React from 'react'
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import { getEnvVar } from '@mc/client-env'
import { Button, IconSocialFacebookDefault } from '@mc/design-system'
import { isInAppBrowser } from '@mc/devices'

interface FacebookButtonProps {
  children?: React.ReactNode | React.ReactNode[] | string
  autoLoad?: boolean
  onLogin?(...args: unknown[]): unknown
  onClick?: () => void
  userAgent?: string
}

const FacebookButton = ({
  autoLoad = false,
  onLogin,
  children,
  userAgent = '',
  onClick,
}: FacebookButtonProps) => {
  // see isInAppBrowser to understand why
  if (isInAppBrowser(userAgent)) return null

  return (
    <FacebookLogin
      cookie
      autoLoad={autoLoad}
      isMobile={false}
      appId={getEnvVar('FACEBOOK_KEY')}
      fields='name,email,picture'
      onClick={onClick}
      callback={onLogin}
      scope='public_profile, email'
      render={(props: { onClick: () => void }) => (
        <Button kind='facebook' onClick={props?.onClick} fullWidth>
          <IconSocialFacebookDefault size='lg' className='mc-mr-3' />
          {children}
        </Button>
      )}
    />
  )
}

FacebookButton.defaultProps = {
  autoLoad: false,
  userAgent: '',
}

export default FacebookButton
